import Image from 'next/image'
import { Button } from 'components/Button'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { Content, ShippingRoot } from './Shipping.styles'

import delivery from '../../../../../../../public/assets/raw-food-subscription/delivery.svg'
import { Link } from 'components/Link'

export const Shipping = () => {
  const { t } = useTranslation()

  return (
    <ShippingRoot>
      <Stack direction="column" gap="4" alignItems="center">
        <Stack direction="column" gap="2" alignItems="center">
          <Image src={delivery} />

          <Content>
            <Text as="h2" size="h3" weight="bold" align="center">
              {t('raw-food-subscription:shipping.title')}
            </Text>
          </Content>
          <Content>
            <Text size="headline" align="center">
              {t('raw-food-subscription:shipping.subtitle')}
            </Text>
          </Content>
        </Stack>

        <div>
          <Link href="/meal-plan" passHref>
            <Button as="a">{t('raw-food-subscription:shipping.cta')}</Button>
          </Link>
        </div>
      </Stack>
    </ShippingRoot>
  )
}
